<template>
  <div id="app">
    <keep-alive :include="cached">
        <router-view />
    </keep-alive>
    <playvoice/>
  </div>
</template>

<script>
import playvoice from './components/playVoice/playVoice.vue'
export default {
  name: 'App',
  components: {
    playvoice
  },
  data() {
    return {
        cached: this.$store.state.catchArr
    };
  },
  computed: {

  },
  mounted() {
    // 设置适配字体大小
    const clientWidth = 375;
    const fontSize = 14;
    const html = document.documentElement;
    const nowClientWidth = html.clientWidth;
    const newFontSize = nowClientWidth * fontSize / clientWidth;
    html.style.fontSize = newFontSize + "px";
    console.log(html.style.fontSize)
    // 
    window.localStorage.setItem('j',125)
    this.$store.commit('setisLogin', true)

    // 注册config
    // bgn/wx/configSign
    const path = encodeURIComponent(
      this.$store.state.url + this.$route.path
    );
    // console.log(this.$route.query)
    console.log(location.href.split('#')[0])
    this.$aGet('bgn/wx/configSign',{url: location.href.split('#')[0]}).then(res=>{
      const data = res.data.data;
      this.$wx.config({
        debug: this.$route.query.n ==1?true:false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录1
        jsApiList: [
          "chooseImage",
          "uploadImage",
          "downloadImage",
          "getLocalImgData",
          "chooseWXPay",
          "onMenuShareAppMessage"
        ]
      });
    })
    
   
  },
  watch: {
    $route: {
      //监听路由变化
      handler: function(to, from) {
        this.cached = this.$store.state.catchArr;
      }
    }
  }
  
}
</script>

<style>
#app {
  
}
*{
  margin: 0;
  padding: 0;
}
div,input,textarea{
  box-sizing: border-box;
}
.flexGroup{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f1{
  overflow: hidden;
  text-overflow:ellipsis; white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue